
import Vue from 'vue';
import { IArticle } from '../store/state';
import Article from './Article.vue';

// Interfaces for component typechecking!
interface ListComputed {
	articles: IArticle[]
}

export default Vue.extend<{}, {}, ListComputed, {}>({
	name: 'List',
	computed: {
		articles() {
			return this.$store.getters.articles.list;
		}
	},
	components: {
		Article
	}
})
